<template>
  <div class="ue-tabs" id="ue-tabs">
    <ul 
      id="ue-tabs-ul"
      :style="tabStyle"
      @click.stop="activeTab"
    >
      <li 
        v-for="(item, index) in tabs" 
        :title="item.name" 
        :class="{active: index === activeIndex}" 
        :key="index">{{item.name}}
      </li>
    </ul>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'ue-tabs',
  data () {
    return {
      activeIndex: 0,
      tabStyle: {
        transform: 'translateX(0)'
      },
      tabScrollLeft: true
    }
  },
  props: {
    tabs: Array
  },
  created () {
    this.$emit('loadPost', this.tabs[this.activeIndex].id)
  },
  methods: {
    activeTab: _.debounce(function (event) {
      if(event.srcElement.tagName !== 'LI' ) return
      this.activeIndex = this.tabs.findIndex(ele => ele.name === event.srcElement.title)
      this.$emit('loadPost', this.tabs[this.activeIndex].id)
    }, 250, {
      leading: true
    }),
    tabScroll (event) {
      this.changeTabStyle()
      if(this.tabScrollLeft) {
        event.srcElement.style.transform = 'rotateY(180deg)'
      } else {
        event.srcElement.style.transform = 'rotateY(0deg)'
      }
      this.tabScrollLeft = !this.tabScrollLeft
    },
    changeTabStyle () {
     let scrollWidth = 0
      if (this.tabScrollLeft) {
        scrollWidth = document.querySelector('#ue-tabs-ul').scrollWidth
                      - document.querySelector('#ue-tabs').getClientRects()[0].width + 20
      }
      this.tabStyle.transform = `translateX(-${scrollWidth}px)`
    }
  }
}
</script>
<style lang="scss">
.ue-tabs {
  width: 100%;
  max-width: 850px;
  padding-right: 68px;
  border-bottom: 1px solid rgba(234,234,234,1);
  height: 73px;
  position: relative;
  overflow: hidden;
  >ul {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0;
    height: 74px;
    padding-left: 0;
    transition: transform .3s;
    transform: translateX(0px);
    width: 100%;
    >li{
      display: inline-block;
      list-style: none;
      font-size: 16px;
      color: rgba(51,51,51,1);
      padding: 0 20px;
      text-align: center;
      // text-transform: uppercase;
      height: 74px;
      line-height: 74px;
      flex-grow: 0;
      flex-shrink: 0;
      &:hover{
        cursor: pointer;
        color:rgba(231,0,18,1);
        font-weight: bold
      }
      &::after{
        display:block;
        content:attr(title);
        font-weight:bold;
        visibility:hidden;
        height:1px;
        color:transparent;
        margin-bottom:-1px;
        overflow:hidden;
      }
    }
    .active{
      color:rgba(231,0,18,1);
      font-weight: bold;
      border-bottom: 3px solid rgba(231,0,18,1);
    }
  }
}
</style>


